<template>
    <div class="task-manage-nav" style="display:flex;flex-direction:column;background:rgba(240, 242, 243, 1)">
        <div style="height:56px;line-height:56px;border-bottom:1px solid rgba(229, 229, 229, 1);background:#fff;padding-right:24px;">
            <img style="width:36px;border-radius:4px;margin-left:20px;float:left;margin-top:10px;" src="../assets/img/logo.png" alt="">
            <span style="font-size:18px;color:rgba(51, 51, 51, 1);font-weight:bold;margin-left:12px;">小文短信服务</span>
            <div style="display:inline-block;float:right;color:rgba(121, 136, 155, 1);cursor:pointer;margin-right: 50px;">
                <a-dropdown>
                    <span class="avatar">
                        <span class="name-text">账号信息</span>
                        <!-- <a-icon type="down" /> -->
                    </span>
                    <a-menu slot="overlay" class="">
                        <a-menu-item @click="changePwd">
                            <a href="javascript:;">
                                <span>修改密码</span>
                            </a>
                        </a-menu-item>
                        <a-menu-divider/>
                        <a-menu-item>
                            <a href="javascript:;" @click="loginOut">
                                <span>退出登录</span>
                            </a>
                        </a-menu-item>
                    </a-menu>
                </a-dropdown>
            </div>
        </div>
        <div style="flex:1;width:100%;display:flex;">
            <div style="min-width:240px;height:100%" class="nav">
                <!-- <div @click="selectNav('AccountInfo')" :class="{'active':currentNav=='AccountInfo'}" class="list">
                    <router-link to="/AccountInfo">
                        <a-icon type="contacts" /> 
                        <span>账号信息</span>
                    </router-link>
                </div> -->
                <div @click="selectNav('ReportingManagement')" :class="{'active':currentNav=='ReportingManagement'}" class="list">
                    <router-link to="/ReportingManagement">
                        <a-icon type="switcher" />
                        <span>报备管理</span>
                    </router-link>
                </div>
                <div @click="selectNav('TemplateManagement')" :class="{'active':currentNav=='TemplateManagement'}" class="list">
                    <router-link to="/TemplateManagement">
                        <a-icon type="switcher" />
                        <span>模板管理</span>
                    </router-link>
                </div>
                <div @click="selectNav('SendRecord')" :class="{'active':currentNav=='SendRecord'}" class="list">
                    <router-link to="/SendRecord">
                        <a-icon type="switcher" />
                        <span>发送记录</span>
                    </router-link>
                </div>
                <div @click="selectNav('NumberDictionary')" :class="{'active':currentNav=='NumberDictionary'}" class="list">
                    <router-link to="/NumberDictionary">
                        <a-icon type="read" />
                        <span>号码字典</span>
                    </router-link>
                </div>
                <div @click="selectNav('DictionaryContent')" :class="{'active':currentNav=='DictionaryContent'}" class="list">
                    <router-link to="/DictionaryContent">
                        <a-icon type="profile" />
                        <span>字典内容</span>
                    </router-link>
                </div>
                <div @click="selectNav('SceneSms')" :class="{'active':currentNav=='SceneSms'}" class="list">
                    <router-link to="/SceneSms">
                        <a-icon type="switcher" />
                        <span>场景短信</span>
                    </router-link>
                </div>
            </div>
            <div style="flex:1;padding:16px 24px 32px 16px;">
                <router-view ref="child"></router-view>
            </div>
        </div>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="messageSendModal" title="修改密码" footer='' width='440px'>
            <div class="record-modal1 modal-public">
                <a-divider style="margin:0 0 12px 0;" type="horizontal" />
                <div >
                    <div style="color:rgba(18, 18, 18, 1);font-size:14px;margin-bottom:8px;">请输入手机号：</div>
                    <div>
                        <a-input style="margin-bottom:20px;background:rgba(188, 202, 214, 0.2);height:52px;border:none" size="large" type="text" placeholder="请输入手机号" v-model.trim="telNum">
                        </a-input>
                    </div>
                    <div style="color:rgba(18, 18, 18, 1);font-size:14px;margin-bottom:8px;">请输入验证码：</div>
                    <a-row :gutter="16" style="margin-bottom:20px">
                        <a-col class="gutter-row" :span="16">
                            <div>
                                <a-input style="background:rgba(188, 202, 214, 0.2);height:52px;border:none" size="large" type="text" v-model.trim="registerCode" placeholder="请输入验证码">
                                </a-input>
                            </div>
                        </a-col>
                        <a-col class="gutter-row" :span="8">
                            <a-button
                            v-if="!ifCount2"
                            @click="getMsg2"
                            class="get-captcha"
                            tabindex="-1"
                            >获取验证码</a-button>
                            <a-button
                            v-if="ifCount2" disabled
                            class="get-captcha"
                            tabindex="-1"
                            >{{countNum2}}s后重新获取</a-button>
                        </a-col>
                    </a-row>
                    <div style="color:rgba(18, 18, 18, 1);font-size:14px;margin-bottom:8px;">请输入密码：</div>
                    <div>
                        <a-input
                            v-model.trim="password1"
                            size="large"
                            type="password"
                            placeholder="请输入密码"
                            autocomplete="new-password"
                            style="height:52px;background:rgba(188, 202, 214, 0.2);border:none"
                        >
                        </a-input>
                    </div>
                </div>
                
                <a-divider class="divider2" type="horizontal" />
                <div class="btn-group">
                <a-button type="primary" ghost @click="cancelMessageSend">取消</a-button>
                <a-button type="primary" @click="sureMessageSend">确定</a-button>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
export default {
    name: 'Menu',
    props: {
        msg: String
    },
    data() {
        return {
            currentNav: 'SendRecord',
            messageSendModal: false,
            telNum: '',
            registerCode: '',
            countNum2: 60,
            ifCount2: false,
            timer2: null,
            password1: ''
        }
    },
    methods: {
        selectNav(type) {
            this.currentNav = type
        },
        success(msg) {
            this.$message.success(msg);
        },
        error(msg) {
            this.$message.error(msg);
        },
        warning(msg) {
            this.$message.warning(msg);
        },
        loginOut() {
            this.$router.push("/Login")
        },
        changePwd() {
            this.telNum = ''
            this.password1 = ''
            this.registerCode = ''
            this.messageSendModal = true
        },
        cancelMessageSend() {
            this.messageSendModal = false
            this.telNum = ''
            this.password1 = ''
            this.registerCode = ''
        },
        sureMessageSend() {
            let flag = this.checkPasswordRule(this.password1)
            if(flag){
                this.axios.post('/api/user/updatePassword', {
                    phone: this.telNum,
                    newPassword: this.password1,
                    verifyCode: this.registerCode,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.messageSendModal = false
                        this.telNum = ''
                        this.password1 = ''
                        this.registerCode = ''
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            }
        },
        getMsg2(){
            if(this.telNum.length == 11){
                this.axios.post('/api/verifyCode', {
                    phone: this.telNum,
                    type: '3'
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('短信发送成功')
                        this.ifCount2 = true
                        this.timer2 = setInterval(()=>{
                            this.countNum2 -- 
                            if(this.countNum2 == 0){
                                clearInterval(this.timer2)
                                this.countNum2 = 60
                                this.ifCount2 = false
                            }
                        },1000)
                    }else{
                        this.$message.error(response.data.userTip)
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            }else{
                this.$message.warning('请输入正确手机号码')
            }
        },
        checkPasswordRule(str) {
            // 正则，和后端Java保持一致
            if (str.length < 8) {
                this.$message.warning('密码长度不能小于8位');
                return false;
            }

            const regUpper = /[A-Z]/;
            const regLower = /[a-z]/;
            const regDigit = /[0-9]/;
            const regSpecial = /[!@#$%^&*()_+={};':"\\|,.<>/?-]/;

            if (!regUpper.test(str)) {
                this.$message.warning('必须包含大写英文字母(A-Z)');
                return false;
            }
            if (!regLower.test(str)) {
                this.$message.warning('必须包含小写英文字母(a-z)');
                return false;
            }
            if (!regDigit.test(str)) {
                this.$message.warning('必须包含数字(0-9)');
                return false;
            }
            if (!regSpecial.test(str)) {
                this.$message.warning('必须包含特殊符号 !@#$%^&*()_+={};\':"\\|,.<>/?-');
                return false;
            }
            return true;
        },
    },
    mounted: function() {
        if(sessionStorage.getItem('contentNavItem')){
            this.currentNav = sessionStorage.getItem('contentNavItem')
        }
    },
    beforeDestroy() {
        if (this.timer2) clearInterval(this.timer2)
    },
}
</script>

<style scoped lang="less">
    .task-manage-nav{
        height: 100%;
        .nav{
            background: #fff;
            div.list{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                line-height: 50px;
                height: 50px;
                cursor: pointer;
                a{
                    color: rgba(18, 18, 18, 1);
                    width: 100%;
                    height: 100%;
                    display: inline-block;
                    padding: 0 24px;
                }
                span{
                    margin-left:5px;
                }
            }
            div.active{
                color: rgba(66, 223, 228, 1);
                background: #ECFCFC;
                a{
                    color: rgba(66, 223, 228, 1);
                }
            }
        }
    }
    .record-modal1{
        padding-bottom: 44px;
        .changed-name{
            color: rgba(153, 153, 153, 1);
            font-size: 14px;
        }
    }
    .modal-public{
        .divider1{
            margin: 0px 0 24px 0;
        }
        .divider2{
            margin: 24px 0 12px;
        }
        .btn-group{
            float: right;
        button{
            // width: 64px;
            height: 32px;
            font-size: 14px;
        }
        button:nth-child(1){
            margin-right: 16px;
        }
        }
        .btn-group2{
            float: right;
            button{
                // width: 64px;
                height: 32px;
                font-size: 14px;
            }
            button:nth-child(1){
                background: #fff;
                color: rgba(121, 136, 155, 0.7);
                border: 1px solid rgba(121, 136, 155, 0.5);
                margin-right: 16px;
            }
            button:nth-child(1):hover{
                background: rgba(121, 136, 155, 0.08);
            }
        }
    }
    .get-captcha {
        display: block;
        width: 100%;
        height: 52px;
        border: none;
        line-height: 50px;
        padding-left: 12px;
        font-size: 14px;
        background: rgba(58, 220, 255, 0.5);
        color: #fff;
    }
    .get-captcha:hover{
        color: #fff;
    }
</style>
